import {
    TableRow,
    TableCell,
    TextField,
    IconButton,
    Box,
    Typography,
  } from "@mui/material";
  import { AddCircle, Save, Close } from "@mui/icons-material";
  import { useState } from "react";
  
  interface Props {
    onSave: (itemName: string) => Promise<void> | void;
  }
  
  const AddEnumItemRow: React.FC<Props> = ({onSave, }) => {
    const [editing, setEditing] = useState(false);
    const [newItem, setNewItem] = useState<string>("");

    const reset = () => {
        setNewItem("");
        setEditing(false);
      };
  
      const handleSave = async () => {
        try {
          await onSave(newItem);
          reset();
        } catch (err) {
          console.error("Failed to save item", err);
        }
      };
  
    if (!editing) {
      return (
        <TableRow hover onClick={() => setEditing(true)} sx={{ cursor: "pointer" }}>
          <TableCell colSpan={2} align="center">
            <Typography variant="body2" color="primary">
              <AddCircle fontSize="small" sx={{ mr: 1 }} /> Add new item
            </Typography>
          </TableCell>
        </TableRow>
      );
    }
  
    return (
        <>
      <TableRow>
        <TableCell>
          <TextField
            variant="outlined"
            size="small"
            fullWidth
            value={newItem}
            onChange={(e) => setNewItem(e.target.value)} />
        </TableCell>
       
        <TableCell>
          <Box display="flex" justifyContent="right">
            <IconButton onClick={handleSave} size="small" color="primary" disabled={!newItem.trim()}>
              <Save />
            </IconButton>
            <IconButton onClick={() => setEditing(false)} size="small">
              <Close />
            </IconButton>
          </Box>
        </TableCell>
      </TableRow>
        </>
    );
  };
  
  export default AddEnumItemRow;
